import {
	type RequestStatus,
	errorWithValueStatus,
	getExistingStatusError,
	getExistingStatusValue,
	getRequestStatusMeta,
	idleStatus,
	isErrorRequestStatus,
	isLoadingRequestStatus,
	isSuccessRequestStatus,
	loadingWithValueStatus,
} from "@suse-o11y/request-status";
import {
	type Observable,
	type OperatorFunction,
	distinctUntilChanged,
	filter,
	map,
	share,
	startWith,
	withLatestFrom,
} from "@suse-o11y/rxjs";

/**
 * Enrich next loading and error responses with previous successful values to provide nice user experience
 *
 * @deprecated avoid using anything related to rxjs
 */
export const rehydrateErrorLoadingStatusesWithValue =
	<E, T = unknown, M = unknown>(): OperatorFunction<RequestStatus<E, T, M>, RequestStatus<E, T, M>> =>
	(statuses: Observable<RequestStatus<E, T, M>>): Observable<RequestStatus<E, T, M>> => {
		const sharedStatuses = statuses.pipe(share());
		const successStatuses = sharedStatuses.pipe(filter(isSuccessRequestStatus));
		return sharedStatuses.pipe(
			distinctUntilChanged(),
			withLatestFrom(successStatuses.pipe(startWith(idleStatus()))),
			map(([status, successOrIdleStatus]) => {
				if (isSuccessRequestStatus(successOrIdleStatus)) {
					if (isLoadingRequestStatus(status)) {
						return loadingWithValueStatus<T, M>(
							getExistingStatusValue(successOrIdleStatus),
							getRequestStatusMeta(status),
						);
					}
					if (isErrorRequestStatus(status)) {
						return errorWithValueStatus<E, T, M>(
							getExistingStatusError(status),
							getExistingStatusValue(successOrIdleStatus),
							getRequestStatusMeta(status),
						);
					}
				}
				return status;
			}),
		);
	};
